/* eslint-disable @typescript-eslint/no-explicit-any */
import api from 'services/api';
import { Action, Dispatch } from 'redux';
import { logOut } from 'actions/auth';
import MobileService from 'services/mobile';
import { store } from 'store';
import Logger from 'components/common/helpers/devConsoleLog';
import { AxiosResponse } from 'axios';
import {
  GET_USER_DATA,
  RESET_USER_DATA,
  UPDATE_USER_ERROR,
} from './actionTypes';
import { IUser } from '../types';
import { shortPollTillTrue } from '../utils/helpers/payments';
import { TimeUnit } from '../utils/constants/time';
import { addUserDataToTrackingSession } from '../services/tracking-session';
import { setUserInSentry } from '../utils/helpers/sentry';

export const setUserData = (user: IUser): Action & { payload: IUser } => ({
  type: GET_USER_DATA,
  payload: user,
});

export const getUser = () => async (dispatch: any): Promise<void> => {
  try {
    const { data }: AxiosResponse<IUser> = await api.get('/users');
    setUserInSentry(data);
    dispatch(setUserData(data));
    addUserDataToTrackingSession({ userId: data.id });
  } catch (error) {
    dispatch(logOut());
    Logger('userSignUp error:', error);
  }
};

export const awaitTillUserMatchState = (
  matcher: (user: IUser) => boolean
) => async (dispatch: Dispatch) => {
  let user: IUser | undefined;

  await shortPollTillTrue(
    async () => {
      const { data }: AxiosResponse<IUser> = await api.get('/users');
      user = data;

      return matcher(user);
    },
    { interval: 10 * TimeUnit.Second, retryTimes: Infinity }
  );

  dispatch(setUserData(user!));
};

export const updateEmailUser = (email: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: UPDATE_USER_ERROR,
    payload: [],
  });
  try {
    const { data } = await api.put('/users', { email });
    dispatch(setUserData(data));
  } catch (error) {
    dispatch({
      type: UPDATE_USER_ERROR,
      payload: error.response.data?.message,
    });
    Logger('updateEmailUser error:', error);
  }
};

async function saveDeviceToken(unitId: number) {
  try {
    const role = store.getState()?.auth.user?.user?.type;

    if (role === 'teacher') {
      Logger('Skipping setting device token for teacher');
      return;
    }

    const token = await MobileService.getToken();

    if (token) {
      const setDeviceRes = await api.post(`/push-notification/device`, {
        unitId,
        token,
      });

      Logger('Set device token res', setDeviceRes);
    } else {
      Logger('Set device set device token skipped. No token found.');
    }
  } catch (err) {
    Logger('Set device token error', err);
  }
}

export const setActiveScholar = (id: number) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    localStorage.setItem('activeScholarId', id.toString());

    await saveDeviceToken(id);

    dispatch({
      type: GET_USER_DATA,
      payload: { activeScholarId: id },
    });
  } catch (error) {
    Logger('setActiveScholar error:', error);
  }
};

export const resetUserData = (): { type: string } => {
  return {
    type: RESET_USER_DATA,
  };
};
